import { useSelector } from "react-redux";

import SectionBody from "~/components/pages/section/body";
import SectionNewBody from "~/components/pages/sectionNew/body";
import { SiteTypes } from "~/redux/reducers/paramsReducer";

export default function Section({ section }: any) {
  const { siteType } = useSelector((state: any) => state.params);
  return (
    <>
      {siteType === SiteTypes.Baltex && <SectionBody section={section} />}
      {siteType === SiteTypes.Farkop && <SectionNewBody section={section} />}
      {siteType === SiteTypes.Landing && <SectionBody section={section} />}
    </>
  );
}
